import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { useGetClientesLoginsPaginatedMutation } from '../../../../store/api/endpoints/clientesLoginsApiSlice'

import { getUsuarioPermisos } from '../../../../store/slices/auth'

import Typography from '@mui/material/Typography'
import Breadcrumbs from '@mui/material/Breadcrumbs'

import ButtonIcon from '../../../elementos/ButtonIcon'
import HeaderVista from '../../../elementos/HeaderVista'
import TablaPaginada from '../../../elementos/TablaPaginada'

import Grid from '@mui/material/Grid'
import AddIcon from '@mui/icons-material/Add'
import FactCheckIcon from '@mui/icons-material/TurnedIn'

import EditIcon from '@mui/icons-material/Edit'
import PlaceIcon from '@mui/icons-material/Place'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'

export default function ClientesLogins() {

    const urlParams = useParams()

    const permisosDelUsuario = useSelector(getUsuarioPermisos)

    const thead = []
    thead.push({ label: "ID", align: "right", ordenable: true })
    thead.push({ label: "Nombre", align: "left", ordenable: true })
    thead.push({ label: "Usuario", align: "left", ordenable: true })
    thead.push({ label: "Email", align: "left", ordenable: true })
    thead.push({ label: "Acciones", align: "center", ordenable: false })

    const tbody = []
    tbody.push({ tipo: "texto", valor: "codigo" })
    tbody.push({ tipo: "texto", valor: "nombre" })
    tbody.push({ tipo: "texto", valor: "usuario" })
    tbody.push({ tipo: "texto", valor: "email" })
    let botones = []
    botones.push({ color: "primary", icono: <EditIcon />, ruta: "/clientes/" + urlParams.id + "/app/logins/", valor: "codigo" })
    tbody.push({ tipo: "botones", valor: botones })


    if (permisosDelUsuario.indexOf(3) == -1) return (<p>No tienes acceso a visualizar los usuarios.</p>)

    return (<>
        <Grid container>
            <Grid item xs={12} md={6} style={{ marginBottom: '0px', fontSize: '1.2rem' }}>
                <PeopleAltIcon /> Usuarios
            </Grid>
            <Grid item xs={12} md={6}>
                <div align="right">
                    {
                        permisosDelUsuario.indexOf(10) != -1 &&
                        <ButtonIcon
                            variant="outlined"
                            size="small"
                            color="primary"
                            startIcon={<AddIcon />}
                            to={"/clientes/" + urlParams.id + "/app/logins/nuevo"}
                        >
                            Nuevo
                        </ButtonIcon>
                    }
                </div>
            </Grid>
        </Grid>
        <TablaPaginada
            api={useGetClientesLoginsPaginatedMutation}
            thead={thead}
            tbody={tbody}
            orderDefault={[1, 1]}
            extraParams={{idCliente: urlParams.id}}
        />
    </>)

}

